import React from 'react';

const Casino = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_17369_22577)" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M16.0008 11.1762L19.4483 16.0026L16.0008 20.8291L12.5534 16.0026L16.0008 11.1762Z",
      fill: "#00FFFF"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M31.1698 16.0029C31.1698 24.3804 24.3784 31.1717 16.0009 31.1717C7.62337 31.1717 0.832031 24.3804 0.832031 16.0029C0.832031 7.62532 7.62337 0.833984 16.0009 0.833984C24.3784 0.833984 31.1698 7.62532 31.1698 16.0029ZM14.9666 29.063V25.6015C12.231 25.3113 9.83644 23.8785 8.26944 21.7892L5.29375 23.5531C7.47908 26.6465 10.9712 28.751 14.9666 29.063ZM4.23727 21.7747L7.21256 20.0111C6.65456 18.7903 6.3436 17.4329 6.3436 16.0029C6.3436 14.574 6.65406 13.2176 7.21121 11.9976L4.23584 10.2339C3.38073 11.9745 2.90051 13.9326 2.90051 16.0029C2.90051 18.0743 3.38126 20.0334 4.23727 21.7747ZM5.29187 8.45533L8.26749 10.2191C9.83446 8.12847 12.2298 6.69452 14.9666 6.40425V2.9427C10.97 3.25485 7.47708 5.36045 5.29187 8.45533ZM26.7073 23.5541C24.5219 26.647 21.0301 28.7511 17.0351 29.063V25.6006C19.7682 25.3082 22.1602 23.8751 23.7255 21.7867L26.7073 23.5541ZM27.764 21.7759C28.6203 20.0343 29.1013 18.0747 29.1013 16.0029C29.1013 13.9321 28.6209 11.9736 27.7654 10.2327L24.7832 12.0004C25.3395 13.2198 25.6494 14.5751 25.6494 16.0029C25.6494 17.4318 25.339 18.7882 24.7818 20.0083L27.764 21.7759ZM26.7092 8.45424L23.7275 10.2216C22.1622 8.13183 19.7694 6.69766 17.0351 6.40517V2.94269C21.0312 3.25476 24.5239 5.35992 26.7092 8.45424ZM15.9965 23.5873C20.1853 23.5873 23.581 20.1916 23.581 16.0029C23.581 11.8141 20.1853 8.41843 15.9965 8.41843C11.8078 8.41843 8.41208 11.8141 8.41208 16.0029C8.41208 20.1916 11.8078 23.5873 15.9965 23.5873Z",
      fill: "#00FFFF"
    }
  )),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_17369_22577" }, /* @__PURE__ */ React.createElement("rect", { width: "32", height: "32", fill: "white" })))
);

export { Casino };
//# sourceMappingURL=Casino.js.map
